/*
 * Remote-Web öffnen (docs/remote-web.md, Ablauf 2 und 3).
 *
 * Popup-Blocker: ein window.open nach einem await gilt nicht mehr als Folge
 * des Klicks und wird blockiert. Deshalb öffnet openRemoteWeb das Fenster
 * synchron im Klick, leer, und setzt die Adresse, sobald der Server sie
 * liefert. opener wird vorher gelöst, damit die fremde Oberfläche diesen Tab
 * nicht steuern kann (dieselbe Wirkung wie 'noopener').
 */

import { api, ApiError } from '../api/client';
import { openErrorText, type WebTarget } from './remoteWebModel';

interface OpenResponse { id: string; url: string; ablauf: string }

/** Muss direkt im Klick-Handler aufgerufen werden, ohne await davor. */
export async function openRemoteWeb(plantId: string, clientId: string, ziel: string, target: WebTarget): Promise<void> {
  const win = window.open('', '_blank');
  if (win) {
    try {
      win.document.title = 'Verbindung wird aufgebaut';
      win.document.body.textContent = 'Verbindung zum Gerät wird aufgebaut …';
    } catch {
      // Ohne Platzhalter geht es auch.
    }
  }
  let res: OpenResponse;
  try {
    res = await api.post<OpenResponse>(
      `/api/plants/${encodeURIComponent(plantId)}/clients/${encodeURIComponent(clientId)}/remote-web`,
      { ziel, port: target.port, schema: target.schema },
    );
  } catch (e) {
    win?.close();
    if (e instanceof ApiError) {
      const body = (e.body ?? {}) as { reason?: string; message?: string };
      throw new Error(openErrorText(e.status, body.reason, body.message));
    }
    throw new Error(openErrorText(null));
  }
  if (!win) {
    // Blockiert trotz Klick: noch ein Versuch, sonst sagt es der Aufrufer.
    // Ohne 'noopener', weil window.open damit immer null liefert und sich
    // eine Blockade nicht erkennen liesse; opener wird danach gelöst.
    const again = window.open(res.url, '_blank');
    if (!again) throw new Error('Der Browser hat das neue Fenster blockiert. Bitte Popups für diese Seite erlauben.');
    again.opener = null;
    return;
  }
  win.opener = null;
  win.location.href = res.url;
}
